import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Articles } from "../Articles";
import { NavBar } from "../components/NavBar";
import Text from "../components/Text/Text";

interface HowItWorksProps {
  theme: string;
  toggleTheme: any;
}

const HowItWorksContainer = styled.div`
  display: flex;
  background:#000D30;
  background-size: cover;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 4%;

  @media screen and (max-width: 650px) {
    height: auto;
    padding-top: 10%;
  }
`;

const ArticleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5%;
  margin-left: 10%;
  flex-wrap: wrap;
`;

interface HowItWorksCardProps {
  title: string;
  icon: string;
  description: string;
  onClick: any;
}

const CardContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  border: 1px solid #ffffff90;
  border-radius: 10px;
  width: 25%;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 5%;
  &:hover {
    cursor: pointer;
  }
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }

  @media screen and (max-width: 650px) {
    width: 90%;
  }
`;

const IconContainer = styled.div`
  box-shadow: ${(props) =>
    props.theme.themeType === "dark"
      ? "inset 0 0 0 1000px rgba(110, 191, 244, 0.3)"
      : "inset 0 0 0 1000px rgba(123, 128, 255, 0.3)"};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  text-align: center;
  img {
    margin-top: 3%;
  }
`;

const TitleText = styled(Text)`
  margin-left: 10%;
  margin-top: 5%;
  font-size: 1.5rem;

  @media screen and (max-width: 650px) {
    margin-top: 10%;
  }
`;

const HowItWorksCard = ({
  title,
  icon,
  description,
  onClick,
}: HowItWorksCardProps) => {
  return (
    <CardContainer onClick={onClick}>
      <IconContainer>
        <img src={icon} width={"170px"} height={"170px"} alt=''/>
      </IconContainer>
      <img style={{ visibility: "hidden" }} width={'230px'} height={'230px'} alt={''}/>
      <Text bold={true}>{title}</Text>
      <Text>{description}</Text>
    </CardContainer>
  );
};

const HowItWorksPage = ({ theme, toggleTheme }: HowItWorksProps) => {
  const navigate = useNavigate();
  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} />
      <HowItWorksContainer>
        <TitleText bold={true}>How Does It Work?</TitleText>
        <ArticleContainer>
          {Articles.map((article) => (
            <HowItWorksCard
              key={article.title}
              title={article.title}
              icon={article.icon}
              description={article.description}
              onClick={() => {
                navigate(`/articles/${article.id}`);
              }}
            />
          ))}
        </ArticleContainer>
      </HowItWorksContainer>
    </>
  );
};
export default HowItWorksPage;
